import { AboutGridItem } from "module/types";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "index";
import { getFeaturedWorksImages } from "api/storageManager";
import { setFeaturedWorkImages } from "module/reducers/featuredWorksImageReducer";
import ModalPage from "./layout/ModalPage";
import "sass/components/ThumbnailCardViewGrid.scss";
import { useTranslation } from "react-i18next";

type ThumbnailCardViewGridAboutProps = {
  items: AboutGridItem[];
  onItemClick?: (itemKey: string, title: string) => void;
};

const ThumbnailCardViewGridAbout = ({
  items,
  onItemClick,
}: ThumbnailCardViewGridAboutProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [modalItem, setModalItem] = useState<AboutGridItem>(items[0]);

  const { imageMap, loading, error } = useSelector(
    (state: RootState) => state.featuredWorksImages
  );

  const onClickAbout = async (item: AboutGridItem, e: React.MouseEvent) => {
    e.preventDefault();
    setModalItem(item);
    setShowModal(true);
    onItemClick?.(item.imageKey, item.title);
    if (imageMap[item.imageKey]?.images.length === 0) {
      const images = await getFeaturedWorksImages(item.imageKey);
      dispatch(setFeaturedWorkImages({ key: item.imageKey, images }));
    }
  };

  return (
    <>
      <div className="thumbnail-cardview-grid-container">
        {items.map((item, index) => (
          <div
            className="thumbnail-cardview-grid-cell"
            key={index}
            onClick={(e) => onClickAbout(item, e)}
          >
            <img
              className="thumbnail-cardview-grid-thumbnail"
              alt=""
              src={imageMap[item.imageKey]?.thumbnail.url}
            />
            <div className="thumbnail-cardview-grid-body-container">
              <div className="thumbnail-cardview-grid-title">
                {t("featuredWorks." + item.imageKey + ".title")}
              </div>
              <div className="thumbnail-cardview-grid-subtitle">
                {t("featuredWorks." + item.imageKey + ".subtitle")}
              </div>
              <div className="thumbnail-cardview-grid-type-list">
                {item.types.map((value, imgIndex) => (
                  <div
                    key={imgIndex}
                    className="thumbnail-cardview-grid-type-item bg-gray-700"
                  >
                    {t(`aboutGridItemType.${value}`)}
                  </div>
                ))}
              </div>
              <div className="thumbnail-cardview-grid-view">
                <div className="flex items-center">
                  <div className="height-full">{t("viewProject")}</div>
                  <i
                    className="fa-solid fa-arrow-right text-indigo-400"
                    style={{ marginLeft: "8px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {showModal && (
        <ModalPage
          aboutItem={modalItem}
          images={
            imageMap[modalItem.imageKey] ?? {
              thumbnail: { url: "", orientation: "horizontal" },
              images: [],
            }
          }
          onClick={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default ThumbnailCardViewGridAbout;
